<template>
  <div class="component delivery-schedule">
    <v-row class="no-gutters">
      <v-col class="pt-3">
        <v-label>{{`Schedule ${type == 'pickup' ? 'Pickup': 'Dropoff'}`}}</v-label>
      </v-col>
    </v-row>
    <v-row class="ml-0 mr-0">
      <v-col class="pt-0">
        <v-row justify="center">
          <v-date-picker
            color="var(--primaryColor)"
            flat
            dense
            reactive
            fullWidth
            showCurrent
            type="date"
            v-bind:min="minDate"
            v-bind:max="maxDate"
            elevation="0"
            v-model="pickupSchedule.start"
            class="flat-date-picker mx-0"
            @input="emitValue"
          ></v-date-picker>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script type="text/babel">
import moment from "moment";
import { VRow, VCol, VDatePicker, VLabel } from 'vuetify/lib';

export default {
  /**
         * RunBuggy Create Order - Delivery Schedule Component
         * @displayName Delivery Schedule Component
         *
         * Import and Insert component where you want to use it:
         * import DeliverySchedule from '@/components/orders/create/components/delivery-schedule'
         * <delivery-schedule v:bind:best-delivery-eta="bestDeliveryETA" v-on:input="onInputDeliverySchedule"></delivery-schedule>
         *
         
         */
  name: "components-delivery_schedule-index",
  watch: {
    pickupSchedule: {
      deep: true,
      handler(newValue, oldValue) {
        if (
          newValue &&
          oldValue &&
          (newValue.start !== oldValue.start || newValue.end !== oldValue.end)
        )
          this.emitValue();
      },
    },
  },
  props: {
    /**
     * @model
     */
    value: {
      default: undefined,
    },
    type: {
      required: false,
      default: "pickup",
    },
    pickupWindow: {
      required: false,
      default: moment().add(1, "days").toISOString(),
    },
    dropoffWindow: {
      required: false,
      default: moment().add(3, "days").toISOString(),
    },
  },
  data() {
    return {
      pickupSchedule: {
        confirmed: false,
        priority: 0,
        start: moment(this.pickupWindow).format("YYYY-MM-DD"),
        end: moment(this.pickupWindow).add(1, "days").format("YYYY-MM-DD"),
      },
    };
  },
  methods: {
    emitValue() {
      this.pickupSchedule.confirmed = true;
      this.pickupSchedule.end = moment(this.pickupSchedule.start)
        .add(1, "days")
        .format("YYYY-MM-DD");
      this.$emit("input", this.pickupSchedule);
    },
  },
  computed: {
    today() {
      return moment().toISOString();
    },
    minDate() {
      if (this.type === "pickup") return this.pickupWindow;
      else return this.dropoffWindow;
    },
    maxDate() {
      return moment().add(60, "days").toISOString();
    },
  },
  created() {
    if (this.value && this.type === "pickup") {
      const _value = this.value;
      _value.start = moment(_value.start).format("YYYY-MM-DD");
      this.pickupSchedule = _value;
    }
  },
  beforeMount() {},
  mounted() {},
  beforeDestroy() {},
  mixins: [],
  components: { VRow, VCol, VDatePicker, VLabel },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.delivery-schedule {
  .flat-date-picker {
    box-shadow: unset !important;
    border: 1px solid var(--primaryColor);
    border-radius: 0 0 5px 5px !important;
  }
}
</style>
